import React from 'react';
import Navbar from '../components/Navbar';
import HeroBanner from '../components/HeroBanner';
import Footer from '../components/Footer';
import Breadcrumb from '../components/Breadcrumb';
import { Box, Typography } from '@mui/material';

const About = () => {
    // Breadcrumb items
    const breadcrumbItems = [
        { title: 'Home', path: '/' },
        { title: 'About', path: '/about' },
    ];

    // Page text content
    const pageTitle = "Building Immune Digital Twins";
    const mainText1 = `Welcome to the Building Immune Digital Twins (BIDT) initiative — a global, community-driven effort to develop computational replicas of the human immune system. Our goal is to advance our understanding and treatment of diseases by simulating immune responses tailored to individuals.
    
Whether you’re a researcher, clinician, or data scientist, join us in shaping the future of personalized medicine.`;

    const subTitle1 = "What are immune digital twins?";
    const mainText2 = "Immune digital twins are dynamic computational models designed to simulate how an individual’s immune system responds to infections, therapies, and vaccines. By integrating biological knowledge, clinical data, and modeling techniques, we aim to support:";
    const bulletList1 = [
        "Personalised diagnostics",
        "Predictive Medicine",
        "Targeted therapeutic development",
        "Systems-level understanding of immunity"
    ];
    const image1 = "/images/about1.png";
    const subTitle2 = "Our mission";
    const mainText3 = "We are building an open, collaborative ecosystem for:";
    const bulletList2 = [
        "Curation of high-quality immunology data",
        "Development of reusable and interoperable models",
        "Best practices for constructing and validating digital twins",
        "Integration with platforms like the Virtual Human Twin"
    ];
    const image2 = "/images/about2.png";

    return (
        <>
            <Navbar />
            <HeroBanner
                heroTitle="About"
                heroDescription="Learn more about Building Immune Digital Twins"
                imageUrl="/images/digiTwins.png"
                height="165px"
            />
            <Breadcrumb items={breadcrumbItems} />

            <Box sx={{ padding: '32px', maxWidth: '1300px', margin: '0 auto' }}>
                {/* Page Title */}
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontSize: '24px', fontWeight: 400, color: '#142434', mb: 2 }}>
                    {pageTitle}
                </Typography>

                {/* Main Text 1 */}
                {mainText1.split('\n').map((line, i) => (
                    <Typography
                        key={i}
                        sx={{ fontFamily: 'PT Sans, sans-serif', fontSize: '16px', fontWeight: 400, color: '#142434', mb: 3 }}
                    >
                        {line}
                    </Typography>
                ))}

                {/* SubTitle 1 */}
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontSize: '20px', fontWeight: 400, color: '#142434', mb: 1 }}>
                    {subTitle1}
                </Typography>

                {/* Main Text 2 */}
                <Typography sx={{ fontFamily: 'PT Sans, sans-serif', fontSize: '16px', fontWeight: 400, color: '#142434', mb: 1 }}>
                    {mainText2}
                </Typography>

                {/* Bullet List 1 */}
                <Box component="ul" sx={{ pl: 4, mb: 3 }}>
                    {bulletList1.map((item, i) => (
                        <Typography
                            key={i}
                            component="li"
                            sx={{ fontFamily: 'PT Sans, sans-serif', fontSize: '16px', fontWeight: 400, color: '#142434', mb: 1 }}
                        >
                            {item}
                        </Typography>
                    ))}
                </Box>

                {/* Image 1 */}
                <Box sx={{ textAlign: 'center', mb: 3 }}>
                    <img src={image1} alt="Immune Digital Twins" style={{ maxWidth: '60%', height: 'auto' }} />
                </Box>

                {/* SubTitle 2 */}
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontSize: '20px', fontWeight: 400, color: '#142434', mb: 1 }}>
                    {subTitle2}
                </Typography>

                {/* Main Text 3 */}
                <Typography sx={{ fontFamily: 'PT Sans, sans-serif', fontSize: '16px', fontWeight: 400, color: '#142434', mb: 1 }}>
                    {mainText3}
                </Typography>

                {/* Bullet List 2 */}
                <Box component="ul" sx={{ pl: 4, mb: 3 }}>
                    {bulletList2.map((item, i) => (
                        <Typography
                            key={i}
                            component="li"
                            sx={{ fontFamily: 'PT Sans, sans-serif', fontSize: '16px', fontWeight: 400, color: '#142434', mb: 1 }}
                        >
                            {item}
                        </Typography>
                    ))}
                </Box>

                {/* Image 2 */}
                <Box sx={{ textAlign: 'center', mb: 3 }}>
                    <img src={image2} alt="Mission" style={{ maxWidth: '60%', height: 'auto' }} />
                </Box>
            </Box>

            <Footer />
        </>
    );
};

export default About;
